import { gql } from '@apollo/client';

export const generatePlaygroundCode = gql`
  mutation GeneratePlaygroundCode {
    generatePlaygroundCode
  }
`;
